export default [
    {
        col: 12,
        id: 'program_year',
        icon: 'mdi-ticket',
        label: 'Tahun Program',
        type: 'select-program-year',
        model: '',
        filter: true,
        list: true,
    },
    {
        id: 'form_no',
        icon: 'mdi-calendar',
        label: 'Nomor Form',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'fc_name',
        icon: 'mdi-calendar',
        label: 'Nama FC',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'ff_name',
        icon: 'mdi-calendar',
        label: 'Nama FF',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'mu_name',
        icon: 'mdi-calendar',
        label: 'MU',
        type: 'special-select',
        model: '',
        filter: true,
        list: true,
        specialCase: true,
        items: []
    },
    {
        id: 'kecamatan_name',
        icon: 'mdi-calendar',
        label: 'Kecamatan',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'desa-name',
        icon: 'mdi-calendar',
        label: 'Desa',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'lahan_no',
        icon: 'mdi-calendar',
        label: 'Nomor Lahan',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'socialization_date',
        icon: 'mdi-calendar',
        label: 'Tanggal Sosialisasi',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'kayu_amount',
        icon: 'mdi-calendar',
        label: 'Total Kayu',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'mpts_amount',
        icon: 'mdi-calendar',
        label: 'Total MPTS',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'seed_total',
        icon: 'mdi-calendar',
        label: 'Total Bibit',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'penlub_date',
        icon: 'mdi-calendar',
        label: 'Waktu Pembuatan Lubang Tanam',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'distribution_time',
        icon: 'mdi-calendar',
        label: 'Waktu Distribusi',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'distribution_coordinate',
        icon: 'mdi-calendar',
        label: 'koordinat_distribusi',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'distribution_location',
        icon: 'mdi-calendar',
        label: 'Lokasi Distribusi',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    {
        id: 'planting_date',
        icon: 'mdi-calendar',
        label: 'Waktu Tanam',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
    
    {
        id: 'is_verified',
        icon: 'mdi-calendar',
        label: 'Status',
        type: 'text',
        model: '',
        filter: false,
        list: true,
    },
]